import Vue from 'vue';
import { message } from 'ant-design-vue';
import store from '../store/index';

Vue.directive('has', {
  inserted(el, binding) {
    const { arg } = binding;
    const { isSuperAdmin } = store.getters;
    const { permissions } = store.state.user.info;
    if (!permissions.includes(arg) && !isSuperAdmin) {
      const { innerHTML } = el;
      const a = document.createElement('a');
      a.innerHTML = innerHTML;
      a.style.color = 'rgb(159, 157, 157)';
	  a.addEventListener('click', () => message.error('您没有权限'));
	  el.before(a);
	  el.remove();
    }
  },
});

Vue.directive('super', {
  inserted(el) {
    const { isSuperAdmin, company } = store.state.user.info;
    if (company.length > 0 && !isSuperAdmin) {
      el.remove();
    }
  },
});
